<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<div class="path-header">
  <div class="path">
    <div (click)="onHome()" class="icon"><mat-icon>home</mat-icon><mat-icon>arrow_forward_ios</mat-icon></div>
    <div *ngFor="let p of currentPath.split('/')" (click)="onFile(p)" class="text">
      {{ p }}
      <mat-icon *ngIf="p !== ''">arrow_forward_ios</mat-icon>
    </div>
  </div>
  <div class="tools">
    <button (click)="onUpload()" mat-stroked-button>
      <mat-icon>upload</mat-icon>
    </button>
    <button (click)="onNewFolder()" mat-stroked-button>
      <mat-icon>create_new_folder</mat-icon>
    </button>
    <button (click)="onNewFile()" mat-stroked-button>
      <mat-icon>note_add</mat-icon>
    </button>
  </div>
</div>

<div class="children">
  <div class="child-header-row">
    <div class="child-name">
      <mat-icon></mat-icon>
      <mat-icon></mat-icon>
      Name
    </div>
    <div class="child-share"></div>
    <div class="child-download"></div>
    <div class="child-size">Size</div>
    <div class="child-modified">Modified</div>
  </div>

  <div class="child-row" *ngFor="let c of currentChildren">
    <div class="child-name">
      <mat-icon
        (click)="toggleFavorite(c.name)"
        class="star {{ c.favorite ? 'star-favorite' : 'star-not-favorite' }}"
        >{{ c.favorite ? 'star' : 'star_border' }}</mat-icon
      >
      <span (click)="onFile(c.name)">
        <mat-icon>{{ c.isDirectory ? 'folder' : 'insert_drive_file' }}</mat-icon>
        {{ c.name }}
      </span>
    </div>
    <div class="child-share">
      <mat-icon>share</mat-icon>
    </div>
    <div class="child-download">
      <a [href]="c.url" target="_blank"><mat-icon>download</mat-icon></a>
    </div>
    <div class="child-size">
      {{ c.size | filesize }}
    </div>
    <div class="child-modified">
      {{ c.modified | amTimeAgo }}
    </div>
  </div>
</div>
